import { render, staticRenderFns } from "./JoinWant.vue?vue&type=template&id=8ec54aba&scoped=true&"
import script from "./JoinWant.vue?vue&type=script&lang=js&"
export * from "./JoinWant.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=8ec54aba&prod&scoped=true&lang=css&"
import style1 from "./JoinWant.vue?vue&type=style&index=1&id=8ec54aba&prod&scoped=true&lang=css&"
import style2 from "./JoinWant.vue?vue&type=style&index=2&id=8ec54aba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec54aba",
  null
  
)

export default component.exports